import React from "react";
import "./Button.css";

export const Button = ({
  children,
  variant = "primary",
  size = "large",
  className = "",
  selected = false,
  type = "button",
  ...props
}) => {
  const buttonClasses = [
    "ashara-btn",
    `ashara-btn--${variant}`,
    `ashara-btn--${size}`,
    selected ? "is-selected" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type={type} className={buttonClasses} {...props}>
      {children}
    </button>
  );
};

export default Button;